/***************************************************************************
 * Constants for the row-edit mechanism. Kept in one place so product-
 * driven tuning (min widths, banner timing) doesn't require hunting
 * through cell components.
 ***************************************************************************/

export const MIN_EDIT_COLUMN_WIDTHS: { [formFieldType: string]: number } = {
   "text": 160,
   "number": 120,
   "date": 160,
   "datetime-local": 200,
   "time": 120,
   "password": 160,
   "file": 240,
   "checkbox": 120,
   // Possible-value isn't a `type` in the DynamicFormFieldDefinition sense —
   // it's detected via `formFieldDef.possibleValueProps`. The dispatcher
   // checks that first and looks up this key:
   "possibleValue": 160,
};

/** Default min width for any editable type not explicitly listed above. */
export const DEFAULT_MIN_EDIT_COLUMN_WIDTH = 160;

/** How long the "Saved" indicator stays visible before the row exits edit mode. */
export const SAVE_SUCCESS_BANNER_MS = 3000;

/** Row banner expand/collapse transition duration. */
export const ROW_BANNER_TRANSITION_MS = 150;

/** Cell horizontal padding during edit (display mode is 10px). */
export const EDIT_CELL_HORIZONTAL_PADDING_PX = 4;

///////////////////////////////////////////////////////////////////////////////
// Vertical space reserved inside the editing row for the portaled            //
// EditingRowBannerOverlay (a single line of centered red text for formDisabled //
// / saveError).  RowBanner's maxHeight is 32; pad to 36 so its descenders    //
// don't clip against the row below.                                          //
///////////////////////////////////////////////////////////////////////////////
export const ROW_BANNER_RESERVED_HEIGHT_PX = 36;
